import type { Client, RequestContext } from "../client";
import type { RouteArgs } from "../resolver";
import type { GitCredentialResource, GitCredentialUsage } from "../resources";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";

type GitCredentialsListArgs = ListArgs &
    RouteArgs & {
        name?: string;
    };

export class GitCredentialRepository extends BasicRepository<GitCredentialResource, GitCredentialResource, GitCredentialsListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("GitCredentials", client, requestContext);
    }
    usage(gitCredential: GitCredentialResource) {
        return this.client.get<GitCredentialUsage>(this.requestContext, gitCredential.Links.Usage);
    }
}
